export const HealthSafety = {
    videoType : {
        TOOLBOX : 1
    }
}